/* eslint-disable max-lines */
import { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { saveContactInformation } from '../../../services/formService';
import { getEmailVerificationData, mobileValidation } from '../../../services/validationService';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import Contact from './Contact';
import { formatPhoneNumber, formatPhoneNumberForVI, getEmailErrorType } from './ContactUtils';
import { dgiMapping } from '../../../services/dgiMapping';
import { dgiContMapping } from '../../../services/dgiContMapping';
import {
  ELITE_ACCOUNT_EN,
  INVALID_FORMAT_ERR,
  INVALID_FORMAT_ERR_BUNDLE,
  LIBRE_AHORRA_BUNDLE,
  MANDATORY_FIELD_ERR,
  VALIDATION_BACKSPACE,
} from '../../../constants';
import {
  checkInvalidMobileNumber,
  commonTernary,
  contactNameChange,
  isBundle,
} from '../../commonCode';
import { productMapping } from '../../../services/productMapping';
import BundleContact from '../../Bundle/BundleContact';
import NewLayout from '../../Bundle/NewLayout';

/** ContactInformation is the parent comp rendered on UI as a screen 1 for normal account opening process and dgi product flow
 * Its child component is Contact */
function ContactInformation(props) {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const [isValidating, setIsValidating] = useState(false);

  const {
    contactInformation,
    setContactInformation,
    contactInformationErrors,
    setContactInformationErrors,
    isScreenOneDirty,
    setIsScreenOneDirty,
    setIsScreenTwoDirty,
    setIsScreenThreeDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsFundingScreenDirty,
    setFirstName,
    setCurrentPage,
    location,
    language,
    productName,
    setIsFeatureScreenDirty,
    setIsModalSaveLater,
  } = leadGenerationContext;
  const { history } = props;

  useEffect(() => {
    setCurrentPage('contact-info');
    window.scrollTo(0, 0);
    if (contactInformation?.firstName) {
      setFirstName(contactInformation?.firstName);
    }
  }, []);
  const firstNameChange = (e) => {
    if (e.target.value.length <= 10) {
      contactNameChange(
        e,
        leadGenerationContext,
        /^[A-Za-zÑñÁáÉéÍíÓóÚúü]+( [A-Za-zÑñÁáÉéÍíÓóÚúü]+)*$/
      );
    }
  };
  const lastNameChange = (e) => {
    if (e.target.value.length <= 15) {
      contactNameChange(
        e,
        leadGenerationContext,
        /^[A-Za-zÑñÁáÉéÍíÓóÚúü-]+( [A-Za-zÑñÁáÉéÍíÓóÚúü-]+)*$/
      );
    }
  };
  const areaCodeChange = (e) => {
    if (e.target.value.match(/^\d+$/) || e.key === VALIDATION_BACKSPACE) {
      setContactInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      if (e.target.value.length < 3) {
        setContactInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Area Code should have 3 digits',
        }));
      }
      if (e.target.value.length === 3 && contactInformation?.phone?.length === 8) {
        setContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
        setContactInformationErrors((prevState) => ({ ...prevState, phone: '' }));
      }
    } else if (e.target.value === '') {
      setContactInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setContactInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Area Code is Mandatory',
      }));
    } else {
      setContactInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setContactInformationErrors((prevState) => ({
        ...prevState,

        [e.target.name]:
          productMapping(productName) === LIBRE_AHORRA_BUNDLE
            ? INVALID_FORMAT_ERR_BUNDLE
            : INVALID_FORMAT_ERR,
      }));
    }
  };
  const phoneLengthCheck = (e) => {
    if (e.target.value.length < 8) {
      const formattedPhoneNumber = formatPhoneNumber(e.target.value);
      setContactInformation((prevState) => ({
        ...prevState,
        [e.target.name]: formattedPhoneNumber,
      }));
      if (e.target.value.length < 7 || formattedPhoneNumber.length < 7) {
        setContactInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Mobile number should have 7 digits',
        }));
      } else {
        setContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      }
    }
  };
  const phoneNumberLength = (e) => {
    if (e.target.value.length < 15) {
      const formattedPhoneNumber = formatPhoneNumberForVI(e.target.value);
      setContactInformation((prevState) => ({
        ...prevState,
        [e.target.name]: formattedPhoneNumber,
      }));
      setContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      if (e.target.value.length < 10 || formattedPhoneNumber.length < 10) {
        setContactInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Mobile number should have 10 digits',
        }));
      }
    }
  };

  const phoneChange = (e) => {
    if (location !== 'VI') {
      if (e.target.value.match(/^\d/) || e.key === VALIDATION_BACKSPACE) {
        phoneLengthCheck(e);
      } else if (e.target.value === '') {
        setContactInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
        setContactInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: MANDATORY_FIELD_ERR,
        }));
      } else {
        setContactInformationErrors((prevState) => ({
          ...prevState,

          [e.target.name]:
            productMapping(productName) === LIBRE_AHORRA_BUNDLE
              ? INVALID_FORMAT_ERR_BUNDLE
              : INVALID_FORMAT_ERR,
        }));
      }
    } else {
      if (e.target.value && e.target.value.length === 13) {
        e.target.value = formatPhoneNumberForVI(e.target.value);
      }
      if (e.target.value?.match(/^\d/) || e.key === VALIDATION_BACKSPACE) {
        phoneNumberLength(e);
      } else if (e.target.value === '') {
        setContactInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
        setContactInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: MANDATORY_FIELD_ERR,
        }));
      } else {
        setContactInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]:
            productMapping(productName) === LIBRE_AHORRA_BUNDLE
              ? INVALID_FORMAT_ERR_BUNDLE
              : INVALID_FORMAT_ERR,
        }));
      }
    }
  };
  const preferredContactTimeChange = (e) => {
    if (e.target.value.length > 0) {
      setContactInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
      setContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
    } else {
      setContactInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    }
  };
  /** Handle change details for contact fields */
  const handleChange = (e) => {
    // screen dirty flag set to true for dgi flow
    if (dgiMapping(leadGenerationContext.productName)) {
      setIsScreenOneDirty(true);
      setIsScreenTwoDirty(true);
      setIsScreenThreeDirty(true);
      leadGenerationContext.setIsTrustInfoDirty(true);
      leadGenerationContext.setIsFinanceInfoDirty(true);
      leadGenerationContext.setIsFundingScreenDirty(true);
      leadGenerationContext.setIsEdeliveryScreenDirty(true);
    }
    // screen dirty flag set to true for dgi contribution
    else if (dgiContMapping(leadGenerationContext.productName)) {
      setIsScreenOneDirty(true);
      leadGenerationContext.setIsFinanceInfoDirty(true);
    } else if (
      productMapping(productName) === ELITE_ACCOUNT_EN ||
      productMapping(productName) === 'Ahorra'
    ) {
      setIsScreenOneDirty(true);
      setIsScreenTwoDirty(true);
      setIsScreenThreeDirty(true);
      setIsScreenFourDirty(true);
      setIsScreenFiveDirty(true);
      setIsFeatureScreenDirty(true);
      setIsFundingScreenDirty(true);
    }
    // screen dirty flag set to true for normal account opening products
    else {
      setIsScreenOneDirty(true);
      setIsScreenTwoDirty(true);
      setIsScreenThreeDirty(true);
      setIsScreenFourDirty(true);
      setIsScreenFiveDirty(true);
      setIsFundingScreenDirty(true);
    }

    switch (e.target.name) {
      case 'firstName':
        firstNameChange(e);
        break;

      case 'lastName':
        lastNameChange(e);
        break;

      case 'areaCode':
        areaCodeChange(e);
        break;

      case 'phone':
        phoneChange(e);
        break;

      case 'email':
        if (
          e.target.value.match(
            /^([a-zA-Z0-9_.-]+)@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/
          )
        ) {
          const emailFirstPart = e.target.value.split('@');
          if (
            emailFirstPart[0].charAt(0) !== '.' &&
            emailFirstPart[0].charAt(0) !== '-' &&
            emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '-' &&
            emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '.' &&
            !e.target.value.match(/[.\-_]{2,}/)
          ) {
            setContactInformation((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }));
            setContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
          } else {
            setContactInformation((prevState) => ({
              ...prevState,
              [e.target.name]: e.target.value,
            }));
            setContactInformationErrors((prevState) => ({
              ...prevState,
              [e.target.name]:
                productMapping(productName) === LIBRE_AHORRA_BUNDLE
                  ? INVALID_FORMAT_ERR_BUNDLE
                  : INVALID_FORMAT_ERR,
            }));
          }
        } else if (e.target.value === '') {
          setContactInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
          setContactInformationErrors((prevState) => ({
            ...prevState,
            [e.target.name]: MANDATORY_FIELD_ERR,
          }));
        } else {
          setContactInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
          setContactInformationErrors((prevState) => ({
            ...prevState,
            [e.target.name]:
              productMapping(productName) === LIBRE_AHORRA_BUNDLE
                ? INVALID_FORMAT_ERR_BUNDLE
                : INVALID_FORMAT_ERR,
          }));
        }
        break;

      case 'preferredContactTime':
        preferredContactTimeChange(e);
        break;
      default:
        break;
    }
  };
  /**
   * call save api for normal account opening products */
  const saveData = async (emailValidationDataOne, phoneValidationData) => {
    const data = { ...contactInformation };
    data.applicationId = leadGenerationContext.customerAppId
      ? leadGenerationContext.customerAppId
      : commonTernary(
          leadGenerationContext.applicationId,
          leadGenerationContext.applicationId,
          null
        );
    data.language = leadGenerationContext.language;
    data.location = leadGenerationContext.location;
    data.utmCampaign = leadGenerationContext.utmCampaign;
    data.utmMedium = leadGenerationContext.utmMedium;
    data.utmContent = leadGenerationContext.utmContent;
    data.utmTerm = leadGenerationContext.utmTerm;
    data.utmSource = leadGenerationContext.utmSource;
    data.branchCode = leadGenerationContext.branchCode;
    data.productType = leadGenerationContext.productType;
    data.productName = leadGenerationContext.productName;
    data.emailVerificationResponse = emailValidationDataOne;
    data.phoneValidationResponse = phoneValidationData;
    let response = null;

    response = await saveContactInformation(data, leadGenerationContext.accessToken);

    return response;
  };

  /**
   * form fields mandatory check before save call */
  const isFormValid = () => {
    let valid = true;
    if (!contactInformation?.firstName) {
      valid = false;
      setContactInformationErrors((prevState) => ({
        ...prevState,
        firstName: MANDATORY_FIELD_ERR,
      }));
    }
    if (!contactInformation?.lastName) {
      valid = false;
      setContactInformationErrors((prevState) => ({
        ...prevState,
        lastName: MANDATORY_FIELD_ERR,
      }));
    }
    if (!contactInformation?.email) {
      valid = false;
      setContactInformationErrors((prevState) => ({
        ...prevState,
        email: MANDATORY_FIELD_ERR,
      }));
    }
    if (!contactInformation?.phone) {
      valid = false;
      setContactInformationErrors((prevState) => ({
        ...prevState,
        phone: MANDATORY_FIELD_ERR,
      }));
    }
    if (!contactInformation?.areaCode) {
      valid = false;
      setContactInformationErrors((prevState) => ({
        ...prevState,
        areaCode: MANDATORY_FIELD_ERR,
      }));
    }
    for (const key in contactInformationErrors) {
      if (contactInformationErrors[key]) {
        valid = false;
        break;
      }
    }
    return valid;
  };

  const mobileValidCheck = (response, errorToShowElement) => {
    let isValid = false;
    if (response && response.status === 200) {
      if (response.data[0] && response.data[0]?.status === 'Invalid') {
        setContactInformationErrors((prevState) => ({
          ...prevState,
          [errorToShowElement]: `* ${response.data[0].message}`,
        }));
        const element = document.getElementById(errorToShowElement);
        if (element) {
          element.focus();
        }
      }
      if (response.data[0] && response.data[0]?.status === 'Valid') {
        isValid = true;
        setContactInformationErrors((prevState) => ({ ...prevState, [errorToShowElement]: '' }));
      }
    }
    return isValid;
  };
  /**
   * Mobile number melisa validation for location VI & PR */
  const validateMobile = async (areaCode, errorToShowElement, phone) => {
    let valid = false;
    let phoneNumber1 = null;
    let response1 = null;
    if (location === 'VI') {
      phoneNumber1 = phone?.replace(/\D+/g, '');
      if (phoneNumber1 && phoneNumber1?.length === 10) {
        response1 = await mobileValidation(phoneNumber1, leadGenerationContext.accessToken);
      }
    } else {
      phoneNumber1 = `${areaCode}${phone}`;
      if (phoneNumber1 && phoneNumber1?.length === 11) {
        response1 = await mobileValidation(phoneNumber1, leadGenerationContext.accessToken);
      }
    }
    valid = mobileValidCheck(response1, errorToShowElement);
    return { isPhoneValid: valid, validationResponse: response1 ? response1?.data[0] : null };
  };
  let emailValid = false;
  let emailErrorType = null;
  let emailValidationData = null;
  const emailVaildCheck = (data) => {
    if (data.status === 'Valid') {
      emailValid = true;
      setContactInformationErrors((prevState) => ({ ...prevState, email: '' }));
    } else {
      setContactInformationErrors((prevState) => ({
        ...prevState,
        email: `* ${data.message}`,
      }));
      emailErrorType = getEmailErrorType(data.message);
    }
  };
  /**
   * email melisa validation and invalid format message check */
  const emailValidation = async () => {
    if (
      contactInformationErrors?.email ===
      (productMapping(productName) === LIBRE_AHORRA_BUNDLE
        ? INVALID_FORMAT_ERR_BUNDLE
        : INVALID_FORMAT_ERR)
    ) {
      const emailElement = document.getElementById('email');
      emailElement.setSelectionRange(0, contactInformation?.email?.length);
      emailElement.focus();
    } else if (contactInformation?.email) {
      const response = await getEmailVerificationData(
        contactInformation?.email,
        leadGenerationContext.accessToken
      );
      if (response && response.status === 200 && response.data[0]) {
        const data = response.data[0];
        emailVaildCheck(data);
        emailValidationData = data;
      }
      /**
       * email field domain and mailbox error message check */
      if (emailErrorType) {
        let emailhighlightStartIndex = 0;
        let emailhighlightEndIndex = 0;
        const emailElement = document.getElementById('email');
        if (emailErrorType === 'Mailbox_Error') {
          emailhighlightEndIndex = contactInformation?.email.indexOf('@');
          emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
          emailElement.focus();
        }
        if (emailErrorType === 'Domain_Error') {
          emailhighlightStartIndex = contactInformation.email.indexOf('@') + 1;
          emailhighlightEndIndex = contactInformation?.email.length;
          emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
          emailElement.focus();
        }
      }
    }
    return { valid: emailValid, validationData: emailValidationData };
  };
  const fieldErrorCheck = (fields) => {
    for (const field of fields) {
      if (!contactInformation[field]) {
        const element = document.getElementById(field);
        if (element) {
          element.focus();
          break;
        }
      }
    }
  };
  /**
   * Focus check for mandatory fields of normal account opening products */
  const contactInfoFocusCheck = () => {
    let isElementFound = false;
    const fields = ['firstName', 'lastName', 'email', 'phone', 'areaCode'];
    for (const field of fields) {
      if (contactInformationErrors[field]) {
        const element = document.getElementById(field);
        if (element) {
          isElementFound = true;
          element.focus();
          break;
        }
      }
    }
    if (!isElementFound) {
      fieldErrorCheck(fields);
    }
  };
  /**
   * With successful save status 201, If the flow is DGI contribution, it will be routed to Funding screen(Screen 2)
   * With successful save status 201, If the flow is account opening process, it will be routed to Personal Information screen(Screen 2) */
  const validateResult1 = (result) => {
    if (result?.data?.applicationId) {
      leadGenerationContext.setApplicationId(result.data.applicationId);
      setIsValidating(false);
      if (dgiContMapping(leadGenerationContext.productName)) {
        setIsScreenOneDirty(false);
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/funding-info`
        );
      } else {
        setIsScreenOneDirty(false);
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/personal-info`
        );
      }
    }
  };
  const validatePhoneEmail = async (valid, validation, phoneValidation) => {
    if (valid && validation && validation?.valid === true && phoneValidation?.isPhoneValid) {
      const result = await saveData(
        validation?.validationData,
        phoneValidation?.validationResponse
      );
      if (result && result.status === 201) {
        validateResult1(result);
      }
      // }
    } else {
      if (
        contactInformationErrors?.email ===
        (productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR)
      ) {
        const emailElement = document.getElementById('email');
        emailElement.setSelectionRange(0, contactInformation?.email?.length);
        emailElement.focus();
      } else {
        contactInfoFocusCheck();
      }
      setIsValidating(false);
    }
  };

  /**
   * handle back button
   */
  const handleBack = (e) => {
    e.preventDefault();

    history?.push({
      pathname: `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
        productName
      )}/certificate-of-deposit`,
    });
  };

  /**
   * Handle continue button */
  const handleContinue = async (e) => {
    e.preventDefault();
    setIsValidating(true);

    if (isScreenOneDirty) {
      let phoneValidation = false;
      if (
        contactInformation?.phone &&
        checkInvalidMobileNumber(contactInformation.phone, leadGenerationContext)
      ) {
        setContactInformationErrors((prevState) => ({
          ...prevState,
          phone: '* Invalid Phone',
        }));
      } else {
        phoneValidation = await validateMobile(
          contactInformation?.areaCode,
          'phone',
          contactInformation?.phone
        );
      }
      const validation = await emailValidation();
      const valid = isFormValid();

      await validatePhoneEmail(valid, validation, phoneValidation);
    } else {
      setIsValidating(false);
      if (dgiContMapping(leadGenerationContext.productName)) {
        setIsScreenOneDirty(false);
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/funding-info`
        );
      }
      // else if (leadGenerationContext.productName === 'Consumer Credit') {
      //   setIsScreenOneDirty(false);
      //   history.push(
      //     `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
      //       productName
      //     )}/loan-preference`
      //   );
      // }
      else {
        setIsScreenOneDirty(false);
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/personal-info`
        );
      }
    }
    // loader state
    setIsValidating(false);
  };
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };

  const bundleContact = () => (
    <NewLayout isValidating={isValidating} handleContinue={handleContinue} isBundle>
      <BundleContact handleChange={handleChange} />
    </NewLayout>
  );

  const contact = () => (
    <Contact
      handleChange={handleChange}
      isValidating={isValidating}
      handleContinue={handleContinue}
      handleBack={handleBack}
      handleSaveApplication={handleSaveApplication}
    />
  );

  const contactInfoJsx = commonTernary(isBundle(productName), bundleContact(), contact());

  return contactInfoJsx;
}

export default withRouter(ContactInformation);

ContactInformation.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
